module.exports = {
  title: 'Family Action Tray with Reanimated and Gesture Handler',
  author: 'Enzo Manuel Mangano',
  date: '2023-11-15',
  slug: 'action-tray',
  tags: ['reanimated', 'gesture-handler'],
};
